import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { BRAND } from "@/lib/brand";

const DISMISS_KEY = "vinconex-install-dismissed";

export function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) || window.matchMedia("(display-mode: standalone)").matches) return;
    const onPrompt = (e) => {
      e.preventDefault();
      setEvt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };
  const install = async () => {
    if (!evt) return;
    evt.prompt();
    await evt.userChoice;
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div data-testid="install-app-prompt" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-96 z-50 rounded-xl border border-[#0A8CF2]/40 bg-[#0B0F18]/95 backdrop-blur p-4 shadow-2xl shadow-blue-900/40 flex items-center gap-3">
      <img src={BRAND.mark} alt="" className="h-9 w-auto" />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-white">Install Vinconex</div>
        <div className="text-xs text-slate-400">Add the dashboard to your home screen for one-tap access.</div>
      </div>
      <button onClick={install} data-testid="install-app-btn" className="h-9 px-3 rounded-md bg-[#0A8CF2] hover:bg-[#3AA3FF] text-white text-sm font-bold flex items-center gap-1.5">
        <Download className="h-3.5 w-3.5" /> Install
      </button>
      <button onClick={dismiss} data-testid="install-app-dismiss" className="text-slate-500 hover:text-white"><X className="h-4 w-4" /></button>
    </div>
  );
}
